import { render, staticRenderFns } from "./TabelaGestaoRelatorioRastreabilidade.vue?vue&type=template&id=2b7d3a0c&lang=pug"
import script from "./TabelaGestaoRelatorioRastreabilidade.vue?vue&type=script&lang=js"
export * from "./TabelaGestaoRelatorioRastreabilidade.vue?vue&type=script&lang=js"
import style0 from "./TabelaGestaoRelatorioRastreabilidade.vue?vue&type=style&index=0&id=2b7d3a0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports